import React, {useState, useEffect, useRef} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getTagsForAdmin } from '../../actions/AdminFilterActions';
import { addCategoryTag } from '../../actions/AdminCategoryActions';

const AddTagComponent = (props) => {

    const [isActive, setIsActive] = useState(false)
    const [value, setValue] = useState("")
    const [page, setPage] = useState(1)

    const dispatch = useDispatch()
    const {adminTagsLoading, adminTags} = useSelector(state => state.adminTags)

    const activityTagRef = useRef()

    const handleScroll = event => {
        const {scrollTop, clientHeight, scrollHeight} = event.currentTarget;
        let h
        h = Math.round(scrollHeight - scrollTop)
        if(h === clientHeight || h+1 === clientHeight || h-1 === clientHeight){
          setPage(prev => prev + 1)
        }
      }

    useEffect(()=>{
        document.addEventListener("mousedown", (event) => {
            if (activityTagRef == null || activityTagRef.current == null || !activityTagRef.current.contains(event.target)){
                setIsActive(false)
            }
        })
    }) 


    useEffect(()=>{
        setPage(1)
        const identifer = setTimeout(()=>{
            if (value){
                dispatch(getTagsForAdmin(value, 1, 0))
            } else {
                dispatch(getTagsForAdmin(" ", 1, 0))
            }
        }, 500)  

        return () => { clearTimeout(identifer) }

    },[value])

    useEffect(()=>{
        if (value){
            dispatch(getTagsForAdmin(value, page, 1))
        } else {
            dispatch(getTagsForAdmin(" ", page, 1))
        }
    }, [page])


    const chooseHandler = (tag) => {
        dispatch(addCategoryTag(props.category_id, tag.id))
        setIsActive(false)
        setValue("")
    }

    return (
            <div style={{width: "100%"}}>
                <div className = 'd-flex w-100 bg-warning rounded py-2 flex-wrap'>
                    <input
                        type="text"
                        className="fs-5 border-0 bg-warning text-white search-input flex-grow-1 ps-3"
                        placeholder='Select...'
                        onChange={(e)=>setValue(e.target.value)}
                        onClick={()=>{setIsActive(true)}}
                        value = {value}/>
                </div>
                {
                    isActive ?
                    <div className = "w-100 position-relative d-flex justify-content-end" 
                        style={{userSelect:"none"}} ref = {activityTagRef}>
                        <div className = "w-100 position-absolute mt-3 text-dark p-2 bg-white shadow rounded" 
                            style = {{zIndex:1000}}>
                            <div className='addToplaylist-list-wrapper'
                                onScroll = {handleScroll}
                                style={{maxHeight:"20rem"}}
                            >
                                {
                                    adminTagsLoading ? <>Loading...</> :
                                    adminTags && adminTags.length ? 
                                    adminTags.filter(item=>!props.tags.map(i=>parseInt(i.id)).includes(parseInt(item.id))).map((item) => (
                                        <div
                                            className = "px-1 py-2 text-dark addSearchDropdown-item"
                                            role = "button"
                                            style={{transition:"all 0.2s", wordBreak:"normal", lineHeight:"1.125rem"}}
                                            key = {item.id}
                                            onClick = {()=>chooseHandler(item)}
                                        >{item.title.toLowerCase()}</div>
                                    )) : <div className='text-dark'>No result</div>
                                }
                            </div>
                        </div>  
                    </div> : "" 
                }
            </div>
    );
};

export default AddTagComponent;